import { Center, Container, Image, Text, VStack } from '@chakra-ui/react';

function RequestParcelCompleted() {
  return (
    <Center px={'16px'} h={'100%'}>
      <VStack gap={0} h={'100%'} justifyContent={'center'}>
        <Image src="/assets/images/icn_exclaim_circle.svg" boxSize={'56px'} />
        <Text
          fontSize={'22px'}
          fontWeight="semibold"
          color={'#000000'}
          mt={'16px'}>
          운송장 등록 · 변경이 완료되었습니다.
        </Text>
      </VStack>
    </Center>
  );
}

export default RequestParcelCompleted;
